import React from 'react';

const { Provider, Consumer } = React.createContext(null);

export { Provider, Consumer };
